module.exports = __webpack_public_path__ + "img/system.748291a0.png";